import React from 'react';

// SVG Inline
import SVG from 'react-inlinesvg';

import ElevatorSrc from 'assets/images/icons/DesignSysten2.0/miscellaneous/Elevador.svg';
import EscalatorSrc from 'assets/images/icons/DesignSysten2.0/miscellaneous/Escada Rolante.svg';
import StairSrc from 'assets/images/icons/DesignSysten2.0/miscellaneous/Escadas.svg';
import AccessRampSrc from 'assets/images/icons/DesignSysten2.0/miscellaneous/Rampa Acesso.svg';
import PublicToiletSrc from 'assets/images/icons/DesignSysten2.0/miscellaneous/Toilet.svg';
import SuggestionBoxSrc from 'assets/images/icons/DesignSysten2.0/miscellaneous/Caixa.svg';
import SinkSrc from 'assets/images/icons/DesignSysten2.0/miscellaneous/Bebedouro.svg';
import AccessibleSinkSrc from 'assets/images/icons/DesignSysten2.0/miscellaneous/Bebedouro Acessivel.svg';
import FoodCourtSrc from 'assets/images/icons/DesignSysten2.0/miscellaneous/Alimentação.svg';
import ArCondictioningSrc from 'assets/images/icons/DesignSysten2.0/miscellaneous/Ar Condicionado.svg';
import AccessibilityScr from 'assets/images/icons/DesignSysten2.0/miscellaneous/Acessibilidade 4.svg';
import BookScr from 'assets/images/icons/DesignSysten2.0/miscellaneous/Book.svg';

interface SVGInlineInterface {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const FoodCourt: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={FoodCourtSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Book: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={BookScr}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const ArCondictioning: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={ArCondictioningSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const AccessibleSink: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={AccessibleSinkSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const Accessibility: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={AccessibilityScr}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Sink: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={SinkSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const SuggestionBox: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={SuggestionBoxSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const PublicToilet: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={PublicToiletSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const AccessRamp: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={AccessRampSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Stair: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={StairSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Escalator: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={EscalatorSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Elevator: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={ElevatorSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
